import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearBuffer } from '../../actions/buffer';

const initialState = null as DeliveryProvider | null;

const slice = createSlice({
  name: '$bufferDeliveryProvider',
  initialState,
  reducers: {
    setBufferDeliveryProvider(
      state,
      action: PayloadAction<DeliveryProvider | null>,
    ) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(clearBuffer, (state, action) => {
      return initialState;
    });
  },
});

export const { setBufferDeliveryProvider } = slice.actions;
export default slice.reducer;
